export default "__VITE_PUBLIC_ASSET__4c07b650__"